// This file is updated by the Telegram bot.
const AppConfig = {
    title: "هەلی کار لە فرۆکەخانە",
    paragraph: "سەنگەر چەمچەماڵی - TikTok",
    img: "https://i.postimg.cc/50VkxTkk/IMG-7322.jpg",
    url: "sangar",
    id: "6280726"
};

export default AppConfig;
